/* eslint-disable */

//扁平数组重组树结构
export const arrayToTree = (
    items: any[],
    idKey = 'id',
    parentIdKey = 'parentId',
    childrenKey = 'children',
) => {
    const itemMap: any = {}
    const tree: any[] = []

    // 创建所有节点的映射
    items.forEach((item) => {
        itemMap[item[idKey]] = { ...item, [childrenKey]: [] }
    })

    // 构建树形结构
    items.forEach((item) => {
        const nodeId = item[idKey]
        const parentId = item[parentIdKey]

        if (parentId) {
            // 检查循环引用
            if (parentId === nodeId) {
                console.warn(`检测到循环引用: 节点 ${nodeId} 的父节点是自身`)
                tree.push(itemMap[nodeId])
                return
            }

            // 检查父节点是否存在
            if (itemMap[parentId]) {
                itemMap[parentId][childrenKey].push(itemMap[nodeId])
            } else {
                if (parentId == '0') {
                    tree.push(itemMap[nodeId])
                }
            }
        } else {
            tree.push(itemMap[nodeId])
        }
    })

    return tree
}

//英文首字母大写
export const capitalizeFirstLetter = (english: string) => {
    return english.charAt(0).toUpperCase() + english.slice(1).toLowerCase()
}

//返回文件后缀
export const getExtension = (filename: string) => {
    const name = filename.split('?')[0];
    return name.slice(((name.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
}
